import {
  ChangeDetectionStrategy,
  Component,
  inject,
  input,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { Observable } from 'rxjs';
import { Carousel } from 'primeng/carousel';
import { isNotNil } from '@web/utils';
import { BannerLocationType } from '../../../shared/enums/banner-location-type';
import { PublicBannerCollectionItem } from '../../models/public-banner-collection-item';
import { PublicBannerDataSourceService } from '../../services/public-banner-data-source.service';
import { PublicHomePageHeaderBannerCarouselItemComponent } from '../../components/public-home-page-header-banner-carousel-item/public-home-page-header-banner-carousel-item.component';
import { SectionTitleWithOrnamentComponent } from '../../../../../../../../apps/shop-app/src/app/layouts/ui';

@Component({
  selector: 'app-public-home-page-header-banner-carousel',
  imports: [
    CommonModule,
    Carousel,
    PublicHomePageHeaderBannerCarouselItemComponent,
    SectionTitleWithOrnamentComponent,
  ],
  templateUrl: './public-home-page-header-banner-carousel.component.html',
  styleUrl: 'public-home-page-header-banner-carousel.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PublicHomePageHeaderBannerCarouselComponent {
  public readonly styleClass = input<string>();

  private readonly bannerDataSource = inject(PublicBannerDataSourceService);

  protected readonly banners$ = this.bannersSource();
  protected readonly isNotNil = isNotNil;

  protected isMoreThanOne(banners: PublicBannerCollectionItem[]): boolean {
    return banners.length > 1;
  }

  protected areBannersExists(banners: PublicBannerCollectionItem[]): boolean {
    return banners.length > 0;
  }

  private bannersSource(): Observable<PublicBannerCollectionItem[]> {
    return this.bannerDataSource.fetchCollection({
      type: BannerLocationType.HomePageHeader,
    });
  }
}
